import { Component, OnInit, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { LoginService } from './login.service';
import { AppSessionService } from '@shared/session/app-session.service';
import { Router } from '@angular/router';
import { AuthenticateModel } from '@shared/service-proxies/service-proxies';
import { FormGroup } from '@angular/forms';
import { Globals } from 'src/app/app.globals';
import { Platform } from '@ionic/angular';
import { Title } from '@angular/platform-browser';
import { AppConsts } from '@shared/AppConsts';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage extends AppComponentBase implements OnInit {
  AppConsts: AppConsts = AppConsts;
  ngForm: FormGroup;
  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';
  constructor(
    injector: Injector,
    public loginService: LoginService,
    private _sessionService: AppSessionService,
    private router: Router,
    public globals: Globals,
    private platform: Platform,
    private titleService: Title
  ) {
    super(injector);
    this.titleService.setTitle('OACI - Log In');
  }
  
  submitting = false;
  ngOnInit() {
  }

  ionViewWillEnter() {
    this.loginService.authenticateModel = new AuthenticateModel();
    this.loginService.rememberMe = null;
    // this.ngForm.markAsUntouched();
  }

  login(): void {
    this.submitting = true;
    this.loginService.authenticate(() => (this.submitting = false));
  }
  forgotPassword() {
    this.router.navigate(['/account/password-reset']);
  }
  register() {
    this.router.navigate(['/account/register']);
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  isMobile() {
    return this.platform.is('cordova');
  }
}
